import { useEffect, useState } from "react";
import { AppMisc } from "../../../misc/appMisc";
import { useForm } from "react-hook-form";
import AHMIS, { API_URL } from "../../../api/api";
import AddAlertMessage from "../../../components/alert/Alert";
import { ERROR, GHAR_BHETA_SEWA, NAGARIKAROGYA, REQUIRED_FIELD, ROW_PER_PAGE, SOMETHING_WENT_WRONG, SUCCESS } from "../../../utils/constants";
import { Box, Grid, TextField, Typography } from "@mui/material";
import RegisterHeader from "../../../components/register-header/RegisterHeader";
import CustomModal from "../../../components/modal/CustomModal";
import MulDartaaSelect from "../../../components/mul-dartaa-select/MulDartaaSelect";
import PendingPatientList from "../../../components/pending-patient-list/PendingPatientList";
import DeleteRegisterRecordConformation from "../../../components/delete-register-record-conformation/DeleteRegisterRecordConformation";
import NagrikAAarogyaSewaRegister from "../../users/components/register/nagrik-aarogya-sewa-register/NagrikAAarogyaSewaRegister";
import { SessionStorage } from "../../../utils/storage/sessionStorage";
import { MUL_DARTA_NUMBERS_LIST } from "../../../utils/constants/forms";
import { DateUtils } from "../../../utils/dateUtils";
import CustomReactSelect from "../../../components/custom-react-select/CustomReactSelect";
import { useSelector } from "react-redux";

const NagrikAarogyaSewaForm = () => {
  const [modalTitle, setModalTitle] = useState("नागरिक आरोग्य सेवा रजिष्टर थप्नुहोस्।");
  const [showNagrikAarogyaSewaModal, setShowNagrikAarogyaSewaModal] = useState(false)
  const [modalDefaultValues, setModalDefaultValues] = useState({});
  const { register, handleSubmit, setValue, formState: { errors }, reset, watch } = useForm();
  const districtOptions = AppMisc.getDistrictOptions();

  const [totalSize, setTotalSize] = useState();
  const [nagrikAarogyaSewaDataTable, setNagrikAarogyaSewaDataTable] = useState([]);
  const [showNagrikAarogyaSewaDeleteModal, setShowNagrikAarogyaSewaDeleteModal] = useState(false);
  const [nagrikAarogyaSewaDeleteId, setNagrikAarogyaSewaDeleteId] = useState(null);
  const [mulDartaaOptions, setMulDartaaOptions] = useState([]);
  const [pendingPatientList, setPendingPatientList] = useState([])
  const { fromDate, toDate, searchParams } = useSelector((state) => state.dateReducer);
  const { rowsPerPage, pageNumber } = useSelector((state) => state.searchFilter);
  const openNagrikAarogyaSewaModal = () => {
    setShowNagrikAarogyaSewaModal(true);
  }

  const closeNagrikAarogyaSewaModal = () => {
    reset({
      gharBhetGhatSewa: "",
      givanSailiParamarsha: "",
      abhiyanMulakProgramPatak: "",
      otherSewa: "",
      patientFirstName: "",
      patientLastName: "",
      age: "",
      wardNumber: "",
      phoneNumber: "",
      nid: "",
      gaunOrTole: "",
      sewaDartaaNumber: "",
    });
    setShowNagrikAarogyaSewaModal(false);
    setModalDefaultValues()
  }

  const handlePalikaNameChange = (name, value) => {
    setValue(name, value);
  }


  const handleDateChange = (name, dateInMilli) => {
    setValue(name, dateInMilli);
  }

  const submitNagrikAarogyaSewaForm = (data) => {
    if (modalDefaultValues?.id) {
      data.id = modalDefaultValues.id;
    }
    AHMIS.post(API_URL.nagrikAArogya, data)
      .then((response) => {
        if (response.data.type === "success") {
          closeNagrikAarogyaSewaModal()
          nagrikAarogyaSewaPendingPatient()
          getNagrikAarogyaData(fromDate, toDate)
        }
        AddAlertMessage({ type: response.data.type, message: response.data.message })
      })
      .catch((error) => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  };

  useEffect(() => {
    if (fromDate && toDate) {
      getNagrikAarogyaData(fromDate, toDate, searchParams)
    }
  }, [fromDate, toDate, searchParams, pageNumber, rowsPerPage])

  const getNagrikAarogyaData = (fromDate, toDate, searchParams, healthClientId, pageFromParam) => {
    let url = `${API_URL.nagrikAArogya}/fromDateRangeAndPage?fromDate=${fromDate}&toDate=${toDate}&pageNumber=${pageFromParam || (Number(pageNumber))}&rowSize=${rowsPerPage}`;
    if (healthClientId) {
      url = url + "&healthClientId=" + healthClientId;
    }
    if (searchParams) {
      url = url + "&searchParam=" + searchParams;
    }
    AHMIS.get(url)
      .then((response) => {
        let jsondata = response.data;
        setNagrikAarogyaSewaDataTable(jsondata?.data?.objectList || []);
        setTotalSize(jsondata?.data?.size)
      })
      .catch((error) => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      })
  }

  useEffect(() => {
    nagrikAarogyaSewaPendingPatient()
  }, [])

  const nagrikAarogyaSewaPendingPatient = () => {
    let url = `${API_URL.pendingPatient}?sewaType=${"5"}&fiscalYear=${DateUtils.getCurrentFiscalYear()}&registerConstant=${NAGARIKAROGYA}`
    AHMIS.get(url).then((response) => {
      let jsondata = response.data;
      setPendingPatientList(jsondata.data)
    })
      .catch((error) => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      })
  }

  const nagrikAarogyaSewaEdit = (id) => {
    AHMIS.get(API_URL.nagrikAArogya + "/" + id)
      .then((response) => {
        const data = response?.data?.data;
        setModalDefaultValues(data);
        setShowNagrikAarogyaSewaModal(true);

        if (data) {
          Object.keys(data).forEach((key) => setValue(key, data[key]));
        }
      })
      .catch(() => AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG }));
  };

  const handleCustomReactSelectChange = (name, value) => {
    setValue(name, value)
  }

  const closeMulDartaaDeleteModal = () => {
    setShowNagrikAarogyaSewaDeleteModal(false);
    setNagrikAarogyaSewaDeleteId(null);
  }

  const onDeleteNagrikAarogyaSewaRow = (id) => {
    setShowNagrikAarogyaSewaDeleteModal(true);
    setNagrikAarogyaSewaDeleteId(id);
  }

  const deleteNagrikAarogyaRow = (data) => {
    AHMIS.delete(API_URL.nagrikAArogya + "/" + nagrikAarogyaSewaDeleteId + "?deletedReason=" + data.deletedReason)
      .then(response => {
        let jsondata = response.data;
        if (jsondata.type === SUCCESS) {
          setShowNagrikAarogyaSewaDeleteModal(false);
          setNagrikAarogyaSewaDeleteId(null);
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
          getNagrikAarogyaData(fromDate, toDate)
        } else {
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
        }
      })
      .catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  }

  const onHeaderParamChange = (fromDate, toDate, searchParam, healthClientId) => {
    getNagrikAarogyaData(fromDate, toDate, searchParam, healthClientId, 1);
  }

  const attachMulDartaaOptions = () => {
    let mulDartaaOptions = [];
    AHMIS.get(API_URL.mulDartaaNumber + "?sewaType=13&fiscalYear=" + DateUtils.getCurrentFiscalYear())
      .then(response => {
        let data = response.data;
        SessionStorage.setItem(MUL_DARTA_NUMBERS_LIST, data);
        data.forEach(item => {
          mulDartaaOptions.push({ "value": item.mulDartaaNumber, "label": item.mulDartaaNumber + " (" + item.patientFirstName + " " + item.patientLastName + ")", id: item.id });
        });
        setMulDartaaOptions(mulDartaaOptions);
      })
  }

  useEffect(() => {
    attachMulDartaaOptions();
  }, [])

  return (
    <>
      <Box marginTop={3}>
        <RegisterHeader
          registerTitle="नागरिक आरोग्य सेवा रजिष्टर"
          handleModalOpen={openNagrikAarogyaSewaModal}
          onHeaderParamChange={onHeaderParamChange}
          getRegisterData={getNagrikAarogyaData}
          lazyLoading
          showSearchField
        />
      </Box>
      <CustomModal
        title={modalTitle}
        showModal={showNagrikAarogyaSewaModal}
        onModalSubmit={handleSubmit(submitNagrikAarogyaSewaForm)}
        onModalClose={closeNagrikAarogyaSewaModal}
        maxWidth="lg"
        fullScreen
      >
        <Grid container spacing={2} alignItems="center">
          <MulDartaaSelect
            mulDartaaOptions={mulDartaaOptions}
            defaultValues={modalDefaultValues}
            register={register}
            handleSubmit={handleSubmit}
            setValue={setValue}
            errors={errors}
            watch={watch}
            handleSelectedDartaaMitiChange={handleDateChange}
            registerConstant={NAGARIKAROGYA}
          />
        </Grid>
        <Box marginTop={2}>
          <Typography variant="h6">General Examination</Typography>
        </Box>
        <Box mt={2}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={3} >
              <CustomReactSelect
                label="घरभेट सेवा"
                name="gharBhetGhatSewa"
                onChange={handleCustomReactSelectChange}
                options={GHAR_BHETA_SEWA}
                defaultValue={modalDefaultValues?.gharBhetGhatSewa}
                creatable
                register={register}
                required
              />
              {errors?.gharBhetGhatSewa && errors.gharBhetGhatSewa?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
            </Grid>
            <Grid item xs={12} sm={6} md={3} >
              <TextField
                label="जीवनशैली परामर्श जना"
                size="small"
                variant="outlined"
                type="number"
                name="givanSailiParamarsha"
                autoComplete="true"
                fullWidth
                defaultValue={modalDefaultValues?.givanSailiParamarsha}
                {...register("givanSailiParamarsha")}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="अभियान मूलक कार्यक्रम पटक"
                size="small"
                variant="outlined"
                name="abhiyanMulakProgramPatak"
                autoComplete="true"
                type="number"
                fullWidth
                defaultValue={modalDefaultValues?.abhiyanMulakProgramPatak}
                {...register("abhiyanMulakProgramPatak")}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3} >
              <TextField
                label="अन्य सेवा"
                size="small"
                variant="outlined"
                name="otherSewa"
                autoComplete="true"
                defaultValue={modalDefaultValues?.otherSewa}
                fullWidth
                {...register("otherSewa")}
              />
            </Grid>
          </Grid>
        </Box>
      </CustomModal>
      {
        pendingPatientList?.size > 0 &&
        <Box mt={2}>
          <PendingPatientList
            pendingPatientList={pendingPatientList}
            showModal={setShowNagrikAarogyaSewaModal}
            modalDefaultValues={setModalDefaultValues}
            setValue={setValue}
          />
        </Box>
      }
      <DeleteRegisterRecordConformation
        showDeleteModal={showNagrikAarogyaSewaDeleteModal}
        closeDeleteModel={closeMulDartaaDeleteModal}
        deleteRecord={deleteNagrikAarogyaRow}
      />
      <Box mt={2}>
        <NagrikAAarogyaSewaRegister
          onEditRow={nagrikAarogyaSewaEdit}
          tableData={nagrikAarogyaSewaDataTable}
          deleteRow={onDeleteNagrikAarogyaSewaRow}
          totalSize={totalSize}
        />
      </Box>
    </>
  )
}

export default NagrikAarogyaSewaForm;